import Helper from "./Helper";

class Downloadcenter {
  constructor(config = {}) {
    const {
      downloadPage,
      linkItems
    } = config;

    this.downloadPage = document.querySelector(downloadPage);

    if( this.downloadPage) {
      this.linkItems = document.querySelectorAll(linkItems);

      if(this.linkItems){
        this.setHovers();
      }
    }
  }

  setHovers() {
    this.linkItems.forEach(el => {
      el.addEventListener("mouseover", element => {
        this.getPreviousSibling(el.parentNode.parentNode,".ns-title-h2").classList.add("active");
      });

      el.addEventListener("mouseout", element => {
        this.getPreviousSibling(el.parentNode.parentNode,".ns-title-h2").classList.remove("active");
      });
    });
  }

  getPreviousSibling(elem, selector) {
    let sibling = elem.previousElementSibling;
  
    if (!selector) return sibling;

    while (sibling) {
      if (sibling.matches(selector)) return sibling;
      return sibling.previousElementSibling;
    }
  
  };
}

export default Downloadcenter;